import type { VersantLoginState } from '../../shared/versantLogin'
import type { EyemedRowStatus } from './eyemedRowStatus'

/**
 * What a clinic's Versant row on the Integrations list says about the login
 * it uses (openspec change versant-eligibility-lane, frontend/versant-setup).
 * Pure. The states come from `listVersantLogins`, which lists only the
 * clinics holding a Versant record — a clinic it does not list uses no login
 * and reads Not configured. `loading` is that fetch still in flight and
 * `failed` one that did not answer; neither ever reads as Configured.
 */
export type VersantRowInput = VersantLoginState | 'not_configured' | 'loading' | 'failed'

export type VersantRowStatus = EyemedRowStatus

export function versantRowStatus(input: VersantRowInput): VersantRowStatus {
  switch (input) {
    case 'not_configured':
      return { label: 'Not configured', tone: 'grey', counts: false }
    case 'not_set_up':
      return { label: 'Finish setup', tone: 'amber', counts: false }
    case 'set_up':
      return { label: 'Configured', tone: 'green', counts: true }
    case 'paused_admin':
      return { label: 'Checks paused', tone: 'red', counts: false }
    case 'paused_vitalrev':
      return { label: 'VitalRev is fixing', tone: 'grey', counts: true }
    case 'loading':
      return { label: 'Checking…', tone: 'grey', counts: false }
    case 'failed':
      return { label: 'Status unavailable', tone: 'grey', counts: false }
  }
}

/** A clinic's row input from the page's fetch: still loading, failed, the
 *  clinic's login state, or Not configured for a clinic the fetch did not list. */
export function versantRowInput(
  states: ReadonlyMap<string, VersantLoginState> | 'failed' | null,
  clinicId: string,
): VersantRowInput {
  if (states === null) return 'loading'
  if (states === 'failed') return 'failed'
  return states.get(clinicId) ?? 'not_configured'
}
